module.exports = __webpack_public_path__ + "img/shield.0e4487fb.svg";